import { SVGProps, Ref, forwardRef } from 'react';

export const HomeFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path d="M16 6.566H10.03v8.935h.633c4 0 5.332-1.333 5.332-5.332z" fill="currentColor" />
                <path d="M16 5.166H9.331L4.666.501h6.708L16 5.127z" fill="currentColor" />
                <path d="M3.726 1.541 0 5.666v4.503C0 14.168 1.333 15.5 5.332 15.5h3.3V6.446z" fill="currentColor" />
            </g>
        </g>
    </svg>
));
HomeFilledSize16Glyph.displayName = 'HomeFilledSize16Glyph';
